// Copyright (c) 2025. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import { useState, useCallback, useMemo } from 'react';
import { setDoc } from 'firebase/firestore';

export function useSetDocument(ref) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const stableRef = useMemo(() => ref, [JSON.stringify(ref)]);

  const setDocument = useCallback(
    async (...args) => {
      if (!stableRef) return;
      setLoading(true);
      setError(null);
      try {
        await setDoc(stableRef, ...args);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [stableRef],
  );

  return { loading, error, setDocument };
}
